/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "boolean",
    alias: "toggle",
    title: "Boolean",
    description: "Represents a true or false value. No additional attributes beyond required/default.",
    type: "field",
    use: {
        namespace: "ua.checkbox"
    },
    tests: {
        validTrue: {
            must: true,
            run: function () {
                return validate({ title: "Active", type: "boolean" }, true);
            }
        },
        validFalse: {
            must: true,
            run: function () {
                return validate({ title: "Active", type: "boolean" }, false);
            }
        },
        validStringTrue: {
            must: true,
            run: function () {
                return validate({ title: "Active", type: "boolean" }, "true");
            }
        },
        validNumberOne: {
            must: true,
            run: function () {
                return validate({ title: "Active", type: "boolean" }, 1);
            }
        },
        invalid: {
            throw: "fields.boolean.invalid",
            run: function () {
                return validate({ title: "Active", type: "boolean" }, "maybe");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Boolean",
            description: "The value must be interpretable as true or false.",
            template: "Boolean value not valid: ${value}"
        }
    }
});

function validate(spec, value) {
    if (typeof value === "boolean") return;
    if (typeof value === "string") {
        if (value.toLowerCase() === "true" || value.toLowerCase() === "false") return;
    }
    if (typeof value === "number" && (value === 0 || value === 1)) return;

    _.errors.invalid.throw({ value: value });
}
module.exports.validate = validate;
